import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Abrir Caixa", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_7 = { class: "ant-col ant-col-xs-3 ant-col-xl-6" }
const _hoisted_8 = { class: "ant-col ant-col-xs-3 ant-col-xl-6" }
const _hoisted_9 = { class: "ant-col ant-col-xs-5 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_caixa = _resolveComponent("selecionar-caixa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_abertura_caixa = _resolveComponent("selecionar-abertura-caixa")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_abertura_caixa_modal = _resolveComponent("abertura-caixa-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      title: "Confirmar caixa",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      width: 900,
      centered: "",
      "wrap-class-name": 'ss-modal-financeiro'
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-secondary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirCaixa && _ctx.abrirCaixa(...args)))
          }, _hoisted_2),
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
          }, _hoisted_4)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_form_item, {
                  label: "Caixa",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_caixa, {
                      codigoSelecionado: _ctx.state.codigoCaixa,
                      "onUpdate:codigoSelecionado": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.codigoCaixa) = $event)),
                        _ctx.buscarCaixa
                      ],
                      empresas: [_ctx.props.empresa]
                    }, null, 8, ["codigoSelecionado", "empresas", "onUpdate:codigoSelecionado"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_form_item, {
                  label: "Data de Operação",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_data, {
                      dataSelecionada: _ctx.state.data,
                      "onUpdate:dataSelecionada": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.data) = $event)),
                        _ctx.buscarOperadores
                      ]
                    }, null, 8, ["dataSelecionada", "onUpdate:dataSelecionada"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_a_form_item, {
                  label: "Operador",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_usuario, {
                      empresas: [_ctx.props.empresa],
                      usuariosEspecificos: _ctx.state.usuarios,
                      codigoSelecionado: _ctx.state.codigoUsuario,
                      "onUpdate:codigoSelecionado": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.codigoUsuario) = $event)),
                        _ctx.limparAberturaCaixa
                      ],
                      disabled: _ctx.state.codigoCaixa === undefined || _ctx.state.codigoCaixa === 0 || _ctx.state.data === '' || _ctx.state.data === undefined || _ctx.state.usuarios.length === 0,
                      apenasColaboradores: true
                    }, null, 8, ["empresas", "usuariosEspecificos", "codigoSelecionado", "onUpdate:codigoSelecionado", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_form_item, {
                  label: "Abertura",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_abertura_caixa, {
                      caixa: _ctx.state.codigoCaixa,
                      usuario: _ctx.state.codigoUsuario,
                      data: _ctx.state.data,
                      codigoSelecionado: _ctx.state.codigoAberturaCaixa,
                      "onUpdate:codigoSelecionado": [
                        _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.codigoAberturaCaixa) = $event)),
                        _ctx.buscarAberturaCaixa
                      ]
                    }, null, 8, ["caixa", "usuario", "data", "codigoSelecionado", "onUpdate:codigoSelecionado"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_abertura_caixa_modal, {
      visivel: _ctx.state.exibirAberturaCaixa,
      "onUpdate:visivel": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.exibirAberturaCaixa) = $event)),
      empresa: _ctx.props.empresa,
      caixa: _ctx.state.codigoCaixa,
      onConfirmacao: _ctx.buscarOperadores
    }, null, 8, ["visivel", "empresa", "caixa", "onConfirmacao"])
  ], 64))
}